import { Observable } from 'rxjs';
import { AiAssistant, AiConnection, Action, NamespaceConfig } from './ai-assistant.interface';
import { VendorModel } from '@vendasta/ai-assistants';
import { PlatformLocation } from '../ai-assistant.constants';
import { AssistantType } from '@vendasta/ai-assistants';

export interface AssistantInfo {
  assistantId: string;
  iconUrl?: string;
  cardDisabled?: boolean;
  cta?: Action;
  hideCard?: boolean;
  chatEnabled?: boolean;
}

export interface AiAssistantConfig {
  // Current partner ID.
  partnerId$: Observable<string | undefined | null>;

  // Optional: Current market ID
  marketId$: Observable<string | undefined | null>;

  // Optional: Current account group ID.
  accountGroupId$: Observable<string | undefined | null>;

  // Namespace
  namespaceConfig$: Observable<NamespaceConfig | undefined | null>;

  // Optional: default ai assistant list.
  defaultAIWorkforce$: Observable<AiAssistant[] | undefined | null>;

  // Optional: default connection list.
  defaultConnections$: Observable<AiConnection[] | undefined | null>;

  // Optional: current user ID.
  currentUserId$: Observable<string | undefined | null>;

  // Optional: whether the voice AI feature is available.
  voiceAIAvailable$: Observable<boolean | undefined | null>;

  // Optional: whether to show custom assistants based on business rules (e.g., paid SKUs, subscriptions).
  showCustomAssistant$: Observable<boolean | undefined | null>;

  // Optional: current platform location.
  platformLocation: PlatformLocation;

  // Whether the AI Marketer is available.
  aiMarketerAvailable$: Observable<boolean>;

  // Optional: Static capability product map
  capabilityProductMap?: CapabilityProductMap;
  
  // Optional: Assistant product map for white-labeled products (Conversations AI, Reputation Management)
  assistantProductMap$?: Observable<AssistantProductMap>;
}

export interface AiVoice {
  name: string;
  gender: string;
  region: string;
  value: string;
  previewAudioUrl?: string;
  recommended?: boolean;
}

export interface AiVoiceFamily {
  name: string;
  description_key: string;
  voices: AiVoice[];
  provider: VendorModel;
  recommended?: boolean;
}

export interface MeetingType {
  name: string;
  meetingTypeId: string;
  calendarId: string;
}

export interface Association {
  name: string;
  meetingTypeId: string;
  calendarId: string;
}

export enum CalendarType {
  INVALID = 'INVALID',
  PERSONAL = 'PERSONAL',
  GROUP = 'GROUP',
  SERVICE = 'SERVICE',
}

export interface CalendarWithMeetingTypes {
  calendarName: string;
  calendarId: string;
  isPersonal: boolean;
  meetingTypes: MeetingType[];
}

export interface Calendar {
  name: string;
  id: string;
  slug?: string;
  icon: string;
  calendarType: CalendarType;
  associations?: Association[];
}

export interface ProductIcon {
  iconUrl?: string;
  matIcon?: string;
  productName: string;
}

export type CapabilityProductMap = Record<string, ProductIcon>;

export type AssistantTypeProductMap = Partial<Record<AssistantType, ProductIcon>>;

// Combined assistant product map for white-labeled products
export interface AssistantProductMap {
  assistantTypeMap?: AssistantTypeProductMap;
  capabilityIdMap?: CapabilityProductMap;
}
